class QuickJumpBar extends HTMLElement {
    constructor() {
        super();
        this.items = [];
        this.sticky = false;
        this.announcementBarHeight = 0;
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.quick-jump-bar-item');
        this.sticky = this.dataset.sticky === "true";

        this.enableSticky();
        
        const isMobile = `(max-width: 768px)`;
        const isMobileMQL = window.matchMedia(isMobile);
        if(isMobileMQL.matches) {
            console.log("当前为手机端");
            this.attachMobEvents();
            
        }else {
            console.log("当前非手机端");
            this.attachEvents();
        }
        isMobileMQL.addListener(e => {
            if (e.matches) {
                console.log("当前为手机端");
                this.attachMobEvents();
            } else {
                console.log("当前非手机端");
                this.attachEvents();
            }
        });
        this.hasAnnouncementBar();
        this.showJumpBar();
    }

    enableSticky() {
        if (this.sticky) {
            document.body.classList.add('header_no_sticky');
        }
    }

    hasAnnouncementBar() {
        const announcementBar = document.querySelector('.announcement-bar-section');
        if (announcementBar) {
            if(announcementBar.dataset.sticky == true) {
                this.announcementBarHeight = announcementBar.offsetHeight;
                window.addEventListener('resize', () => {
                    this.announcementBarHeight = announcementBar.offsetHeight;
                });
            }
        }
    }

    inTheArea() {
        const viewportCenter = window.innerHeight / 2;
        console.log(viewportCenter,this.offsetHeight)
        this.items.forEach(item => {
            const targetId = item.getAttribute('data-target-id');
            if (targetId) {

                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    const targetElementParent = targetElement.parentElement
                    const rect = targetElementParent.getBoundingClientRect();
                    const top = rect.top - 1;
                    const bottom = rect.height + rect.top;
                    if (this.offsetHeight >= top && this.offsetHeight <= bottom) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                }
            }
        });
    }

    inTheAreaMob() {
        const viewportCenter = window.innerHeight / 2 + window.scrollY;
        this.items.forEach(item => {
            let targetId = item.getAttribute('data-target-mob-id');
            if (!targetId) {
                targetId = item.getAttribute('data-target-id');
            }
            if (targetId) {

                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    const targetElementParent = targetElement.parentElement
                    const rect = targetElementParent.getBoundingClientRect();
                    const top = rect.top - 1;
                    const bottom = rect.height + rect.top;
                    if (this.offsetHeight >= top && this.offsetHeight <= bottom) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                }
            }
        });
    }

    jumpTo(event) {
        const targetId = event.currentTarget.getAttribute('data-target-id');
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            const targetElementParent = targetElement.parentElement
            const offsetTop = this.sticky ? targetElementParent.offsetTop - this.offsetHeight : targetElementParent.offsetTop;
            // console.log(targetElement)
            console.log(targetElementParent.offsetTop,'0',offsetTop,'888',this.offsetHeight)
            window.scrollTo({
                top: offsetTop - this.announcementBarHeight,
                behavior: 'smooth'
            });

        }
        this.scrollItemToCenter(event.currentTarget);
    }

    jumpMobTo(event) {
        let targetId = event.currentTarget.getAttribute('data-target-mob-id');
        if(!targetId) {
            targetId = event.currentTarget.getAttribute('data-target-id');
        }
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            const targetElementParent = targetElement.parentElement
            const offsetTop = this.sticky ? targetElementParent.offsetTop - this.offsetHeight : targetElementParent.offsetTop;

            console.log(targetElement.offsetTop,'0',offsetTop,'888',this.offsetHeight)
            window.scrollTo({
                top: offsetTop - this.announcementBarHeight,
                behavior: 'smooth'
            });

        }
        this.scrollItemToCenter(event.currentTarget);
    }

    scrollItemToCenter(item) {
        const wrapper = this.querySelector('.quick-item-box');
        const wrapperRect = wrapper.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const wrapperScrollLeft = wrapper.scrollLeft;

        const offsetLeft = itemRect.left - wrapperRect.left + wrapperScrollLeft - (wrapperRect.width / 2) + (itemRect.width / 2);

        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    scrollToItem(item) {
        const wrapper = item.parentElement;
        const itemRect = item.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();

        const offsetLeft = itemRect.left - wrapperRect.left + wrapper.scrollLeft;
        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    showJumpBar() {
        const mainContent = document.querySelector('#MainContent');
        const mainProductContainer = mainContent.querySelector('.main-product-container');
        const quickJumpBarSection = document.querySelector('.section-quick-jump-bar');

        if (mainProductContainer && quickJumpBarSection) {
            window.addEventListener('scroll', () => {
                const rect = mainProductContainer.getBoundingClientRect();
                const mainProductContainerBottom = rect.bottom + window.scrollY;

                if (window.scrollY > mainProductContainerBottom) {
                    quickJumpBarSection.classList.add('active');
                } else {
                    quickJumpBarSection.classList.remove('active');
                }
            });
        }
    }

    attachEvents() {
        this.items.forEach(item => {
            item.addEventListener('click', this.jumpTo.bind(this));
            item.addEventListener('click', () => this.scrollToItem(item));
        });

        window.addEventListener('scroll', this.inTheArea.bind(this));
    }

    attachMobEvents() {
         this.items.forEach(item => {
            item.addEventListener('click', this.jumpMobTo.bind(this));
            item.addEventListener('click', () => this.scrollToItem(item));
        });

        window.addEventListener('scroll', this.inTheAreaMob.bind(this));
    }
}

customElements.define('quick-jump-bar', QuickJumpBar);
